import { render, staticRenderFns } from "./energies.vue?vue&type=template&id=020ef9f8&scoped=true"
import script from "./energies.vue?vue&type=script&lang=js"
export * from "./energies.vue?vue&type=script&lang=js"
import style0 from "./energies.vue?vue&type=style&index=0&id=020ef9f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ef9f8",
  null
  
)

/* custom blocks */
import block0 from "./energies.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports